// extracted by mini-css-extract-plugin
export default {"listItem":"DetailList_listItem__M88jx","title":"DetailList_title__2iN59"};